import classNames from 'classnames';
import React from 'react';
import {
  Col,
  Row
} from 'react-bootstrap';
import { Icon } from './';

const SubmissionMessage = ({ innerClassName, children, innerRef, success = true }) => (
  <Row className={classNames(innerClassName, 'no-gutter', 'submissionMessage')}>
    <Col xs={12}>
      <div
        className={classNames('warning', success ? 'green' : 'red')}
        ref={innerRef}>
        {success ? <Icon icon='accept-thick' /> : null} {children}
      </div>
    </Col>
  </Row>
);

export default SubmissionMessage;



// WEBPACK FOOTER //
// ./src/containers/components/submission-message.js